const initialState = {
  noroziFuqaro: false
}

const noroziFuqaro = (state = initialState, action) => {
  switch (action.type) {
    case "NOROZI_FUQARO":
      return { ...state, noroziFuqaro: action.val }
    default:
      return state
  }
}
export default noroziFuqaro
